export default "__VITE_ASSET__D4ca8TlS__"